<template>
  <div class="saved-card-tab">
    <h2 class="title">Select saved card</h2>
    <div class="cards">
      <SavedCard
        v-for="card in savedPaymentMethods"
        :key="card.id"
        :card="card"
        :paymentMethod="paymentMethod"
        @setPaymentMethod="setPaymentMethod"
      />
    </div>
    <div class="cvc-collect">
      <label>Please enter CVC of the card to verify payment</label>
      <div id="payment-cvc"></div>
    </div>
    <div class="error" v-if="paymentError">{{ paymentError }}</div>
    <div class="actions">
      <button class="add-btn" @click="addCard">+ Add a card</button>
      <button class="btn-red" @click="submit">
        <lottie
          v-if="paymentLoading"
          :options="{ animationData: authLoading }"
          :width="24"
          :height="24"
        />
        <span v-else>{{ btnCopy }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex"
import SavedCard from "./SavedCard"
import authLoading from "@/assets/animations/home/authLoading.json"
import Lottie from "vue-lottie"
import { ROUTER_NAMES } from "@/constants/router.constants"
import { PRODUCT_TYPE } from "@/constants/payment"
import { PAYMENT_METHOD } from "@/store/payment/payment.constants"

export default {
  props: {
    productType: {
      type: String,
      default: PRODUCT_TYPE.POINT_PURCHASE,
    },
    btnCopy: {
      type: String,
      default: "PROCEED",
    },
    redirectPath: {
      type: String,
      default: "/dashboard",
    },
    productIds: {
      type: Array,
      require: true,
    },
    promoCodes: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  components: {
    SavedCard,
    Lottie,
  },
  data: function () {
    return {
      authLoading,
      routerNames: ROUTER_NAMES,
      // availableProductTypes: PRODUCT_TYPE,`
      cardCvc: null,
      paymentMethod: null,
    }
  },
  computed: {
    ...mapGetters("Payment", [
      "stripeElements",
      "savedPaymentMethods",
      "paymentError",
      "paymentLoading",
    ]),
    ...mapGetters("Store", [
      "exactRefillProduct",
    ]),
    parsedBtnCopy () {
      const copy = this.btnCopy.toLowerCase()
      return copy[0].toUpperCase() + copy.slice(1)
    },
  },
  methods: {
    ...mapActions("Payment", [
      "initStripeElementsForSavedCard",
      "payWithSavedMethod",
    ]),
    ...mapMutations("Payment", [
      "setCurrentPaymentTab",
      "setPaymentError",
    ]),
    initForm () {
      // Mount Stripe Elements
      this.cardCvc = this.stripeElements.create("cardCvc")
      //  this.cardCvc.clear()
      this.cardCvc.mount("#payment-cvc")
    },
    addCard () {
      this.setCurrentPaymentTab(PAYMENT_METHOD.STRIPE)
    },
    redirectHandle () {
      if (this.redirectPath === window.location.href) {
        this.$emit("extraAction")
      } else {
        window.location.href = this.redirectPath
      }
    },
    async submit () {
      if (this.paymentLoading) {
        return
      }

      const success = await this.payWithSavedMethod({
        productIds: this.productIds,
        paymentMethodId: this.paymentMethod.id,
        cvc: this.cardCvc,
        promoCodes: this.promoCodes,
        exactRefillProduct: this.exactRefillProduct,
      })
      if (success) {
        this.redirectHandle()
      }
    },
    setPaymentMethod (paymentMethod) {
      this.paymentMethod = paymentMethod
    },
    initPaymentMethod () {
      this.setPaymentMethod(this.savedPaymentMethods[0])
    },
  },
  async mounted () {
    await this.initStripeElementsForSavedCard()
    this.cardCvc = this.stripeElements.create("cardCvc")
    // set first card as current payment method
    this.paymentMethod = this.savedPaymentMethods[0]
  },
  watch: {
    savedPaymentMethods (val) {
      if (val.length) {
        this.initPaymentMethod()
      }
    },
    paymentMethod (val) {
      if (val) {
        this.cardCvc.clear()
        this.cardCvc.mount("#payment-cvc")
      }
    },
  },
  beforeDestroy () {
    this.setPaymentError(null)
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_variables.scss";
.saved-card-tab {
  color: #3b3b3b;
  padding: 0 2rem;
  .error {
    background: rgba(250, 200, 206, 0.8);
    color: #db1d3f;
    font-style: normal;
    font-weight: 400;
    font-size: 1.3rem;
    padding: 1rem 1.6rem;
    border-radius: 4px;
    text-align: center;
    margin: 1rem 0;
  }
  .trial-ineligibility {
    color: #545460;
    font-weight: 300;
    font-size: 1.3rem;
    background: #f3f3f3;
    margin-top: 0.5rem;
    margin-bottom: 2rem;
    padding: 1rem;
  }
  .title {
    font-weight: 600;
    font-size: 1.6rem;
    margin-bottom: 1.9rem;
  }
  .cards {
    max-height: 21.8rem;
    overflow: auto;
    margin-bottom: 2rem;
  }
  .actions {
    display: flex;
    flex-direction: column;
    button {
      height: 5rem;
      width: 100%;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      font-size: 1.6rem;
      transition: all 0.1;
      border-radius: 4px;
      font-weight: bold;
      font-family: $font-poppins;
      text-transform: capitalize;
      &.btn-red {
        box-shadow: 0px 4px 30px rgba(244, 37, 86, 0.5);
      }
      &.add-btn {
        color: #3b3b3b;
        background: transparent;
        margin-bottom: 1rem;
        border: 1px solid #3b3b3b;
        &:hover {
          color: #000;
          border-color: #000;
        }
      }
    }
  }
  .disclaimer {
    margin-top: 1.7rem;
    font-weight: 300;
    color: #545460;
    font-size: 1.2rem;
    text-align: left;
    a {
      text-decoration: underline;
    }
  }
}
.cvc-collect {
  label {
    text-align: left;
    font-size: 1.2rem;
    width: 100%;
    display: block;
  }
  #payment-cvc {
    border: 1px solid black;
    margin: 0.5rem 0 1rem;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    width: 6rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/payment/SavedCardTab.vue